import { FormattedMessage } from "react-intl";

import FilePreview from "components/v2/FilePreview/FilePreview";
import { formatDate } from "helpers/dateTimeHelper";
import SupportingText from "./SupportingText";
import { ActivityItemProps } from "./ActivityItemTypes";

interface FilesProps {
  /**
   * The data of message
   */
  files: {
    url: string;
    name: string;
    size?: string;
    onClick?: () => void;
    isLoading?: boolean;
  }[];
  deleted_attachments?: ActivityItemProps["deleted_attachments"];
  is_user_comment?: ActivityItemProps["is_user_comment"];
}

export default function Files({ files, deleted_attachments, is_user_comment }: FilesProps) {
  return (
    <>
      {files.length > 0 && !is_user_comment && (
        <SupportingText>
          <FormattedMessage id="general.attached" defaultMessage="Attached" /> {files.length}{" "}
          <span className="text-lowercase">
            <FormattedMessage id="general.files" defaultMessage="Files" />
          </span>
        </SupportingText>
      )}

      {files.length > 0 && (
        <div className="d-flex flex-wrap gap-lg my-md">
          {files.map((file, index) => (
            <FilePreview
              key={index}
              fileName={file.name}
              url={file.url}
              fileSize={file.size}
              isLoading={file.isLoading}
              onClick={file.onClick}
            />
          ))}
        </div>
      )}

      {deleted_attachments && (
        <div>
          {deleted_attachments.map((attachment, index) => (
            <SupportingText key={index} className="mb-md">
              <FormattedMessage
                id="tracking.activity.deletedTheFile"
                defaultMessage={`Deleted the file "{attachment_name}" on {deleted_at}`}
                values={{
                  attachment_name: attachment.attachment_name,
                  deleted_at: formatDate(attachment.deleted_at, "DD MMM YYYY, HH:mm"),
                }}
              />
            </SupportingText>
          ))}
        </div>
      )}
    </>
  );
}

Files.defaultProps = {
  deleted_attachments: null,
  is_user_comment: false,
};
